import React from 'react'

const Dashboard = () => {
  return (
    <div className="flex">
      <div className="text-center text-gray-400 bg-white rounded-lg p-12 shadow-lg w-1/3 mr-4">
        <h1>Coming Soon!</h1>
      </div>

      <div className="text-center text-gray-400 bg-white rounded-lg p-12 shadow-lg w-1/3 mr-4">
        <h1>Coming Soon!</h1>
      </div>

      <div className="text-center text-gray-400 bg-white rounded-lg p-12 shadow-lg w-1/3">
        <h1>Coming Soon!</h1>
      </div>
    </div>
  )
}

export default Dashboard
